// Module
var code = `<div class="row" ng-repeat="chart_name in [
    'ArenaEventParticipationRateChart',
    'ArenaEventBattlePerUserChart',
    'ArenaEventRetryPerActiveUserChart',
    'ArenaEventRetryGoldSpentChart',
    'ArenaEventCompetitionChart'
]">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="game_events.{{ chart_name }}"></bfg-chart>
    </div>
</div>
`;
// Exports
module.exports = code;